
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexidyDttn2nAtfyKcnzRUSqhwnL7kztssg1Rdvj0_45dfSAMeta } from "/workspace/pages/index.vue?macro=true";
import { default as wishlist0oKfk8Bm9u2a0LDWUpIJm7oEopHDx6AAdS1ADyj_7NgMeta } from "/workspace/pages/wishlist.vue?macro=true";
import { default as _91_46_46_46slug_93G3UImlrGEn_AkohTrBuwPuH5aat5XwRr38Zf6Rv18ggMeta } from "/workspace/pages/[...slug].vue?macro=true";
import { default as component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta } from "/workspace/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I } from "/workspace/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/workspace/pages/index.vue")
  },
  {
    name: "wishlist",
    path: "/wishlist",
    component: () => import("/workspace/pages/wishlist.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/workspace/pages/[...slug].vue")
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/new-generation-of-engineered-surfaces",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/certifications",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/complete-collection-brochure-2019",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/breezy-kitchen-veined-benchtop",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/bianco-molasa",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/davinci-blanco-hamptons-style",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/statuario-supremo",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/surface-stories",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/natural-stone-vs-engineered-stone-benchtops",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/marengo",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/amani-classico",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/calacatta-dior",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/calacatta-extra",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/natural-body-veining-low-silica-quartz-ibrido",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/carrara",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/porcelain",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/nero-astral",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/custom-made-bar-archibuild-expo",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/smart-sustainable-sampling",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/gallery",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/bianco-onix",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/book-matching-low-silica-quartz-ibrido",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/lights-cameras-smartstone",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/fresh-contemporary-kitchen",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/ceniza",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/kitchen-benchtops-brisbane",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/santorini",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/about",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/absolute-blanc",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/astral",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/tag/porcelain-benchtops",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/e-news-sign-up",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/smartstone-",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/triton",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/gelsomino",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/almendra",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-login",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/calacatta-blanco-brightens-southern-queensland-home",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/smartstone-goes-global",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/calacatta-blanco",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/elegant-statuario-dior-benchtops",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/pelle-grigio",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/new-smartstone-collections-2017",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/complete-kitchen-redesign-features-calacatta-blanco",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/test-pages/test-virtual-gallery",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/tag/kitchen",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/tag/amara",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/downloads",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/ibrido",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/inspiration",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/calacatta-blanco-northern-beaches-kitchen",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/statuario-arabescato",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/the-naturale-collection",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/low-silica-quartz-kitchen-benchtops-ibrido",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/destination-smartstone",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product-landing",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/information/kitchen",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/the-hard-facts-natural-stone-vs-engineered-stone-benchtops",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/smart-facts",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/new/product/astral",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/contact//about",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/kitchen-alicia-xiberras-interiors",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/beautiful-home-",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/complete-collection-brochure-2017",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/blanco-naturale",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/dolce-vita-cema",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/old-meets-new-",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/kone-mix",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/white-smartstone-benchtop-helps-queensland-laundry-scrub-beautifully-recent-home-renovation",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product-",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/downloads/ss16-paris_collection_concretoavorio",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/design-vision-achieved-smartstone-amazing-qld-home",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/spring-2019-menu",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/how-to-buy-",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/natural-stone-vs-engineered-stone-benchtops/smartstone_quartz-v-marble-images",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/qld-botanical-abode-smartstone/infocus_august_projects_6",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/nero_astral_lr_rgb",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/calacatta-oro-shines-in-kitchen/bc_harris-kitchens_ss-new",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/how-to-buy-smartstone/smartstone_how-to-page-option-01_gif",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/book-matching-low-silica-quartz-ibrido/smartstone_ibrido_banner_vein_statuario-grigio_rl-01",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/athena_bathroom",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/bathroom-vanity-amara-gremmo",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/designer-kitchen-lynne-bradley-interiors/lb_170306-66-edit",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/quartz-countertop-codef-carrara",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/hume-street-house-featuring-smartstone-athena/vic_sarahhealy_athena4",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/brick-timber-veins",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/stone",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/calacatta-blanco-bench-enhances-functionality-in-timeless-kitchen-design/page/5",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/collection/western-australia",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/low-silica-surfaces-",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/collection/south-australia",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/smartstone-house-rules-bianco-onix/smartstone_oakhurst_feature-image",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/smartstone-",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/builders-collection-flyer-with-categories-2020",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/Statuario-Grigio",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/collection/new-south-wales",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/nombre-3",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/engineered-stone-",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/exclusive-range",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/smartstone-newgen",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/stone-",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/coastal-farmhouse-",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/insights/tips-for-",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/calacattadior",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/paris-4",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/davinci-blanco-",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/locations.kml",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/ca1903_gg_emergency_p1_aw",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/santorinilandscape1",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/grafite-grigio-and-super-white-featured-in-luxury-holiday-home/theridgekitchen_2",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/athena_scandi",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/telopea-st-project",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/paris-3",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product-landing/smartstone_productlanding_hero_2calacatta",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/inspiration/infocus_november_16_473x710_2-2",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/low-",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/downloads-ibrido/smartstone_media-pack_2019-2",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/trade_calacatta_high-2",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/athena_kitchen_crop",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/atlas-plan-italian-porcelain/vl3_press-release-imagery-4",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/Onyx-Verde",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/smartstone-porcelain-safety-data-sheet",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/super-white",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/elegant-",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/gris-naturale",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/adore-home-amara",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/information/kitchen-",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/low-silica-",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/kitchen-island-bench-arcadia-by-atc",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/Tundra-Grigio",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/cremecleanser",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/calacatta-blanco-brightens-southern-queensland-home/page/6",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product-landing/smartstone_productlanding_hero_3carrara",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/milan-5",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/milan-6",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/beautiful-home-renovation-in-north-sydney-features-athena-in-hamptons-style-kitchen/page/4",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/pricecategory2017",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/naturale-downloads/trade_concreto-naturale_high",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/the-new-generation-of-engineered-surfaces-is-coming-soon",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/smartstone_completecollection_digitalbrochure_2016",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/statuario-venato-kitchen-by-charlie-rizk-edge-design",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/banksia-lakes-drive-sanctuary-cove-align-cabinets",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/the-atlas-plan-porcelain-difference/smartstone-atlas-plan-porcelain-collection_photo-1",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/book-matching",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/stockists/stockists-3",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/documents-4",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/downloads/smartstone_2019-spring-launch_video-sound-lowres_3",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/smartstone-houserules-perth/smartstone_bedford-infocus1",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/smartstone-exclusive-veined-surfaces-launch/smartstone_2019_infocus-blog-templates_launch-20194",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/amani-classico/smartstone_hero_amani-classico",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/Statuario Grigio",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/smartstone-houserules-pelle-grigio/smartstone_cranbourne_joint_1200x800",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/statuario-grigio",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/calacatta-blanco-bench-enhances-functionality-in-timeless-kitchen-design/page/2",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/downloads/ss16-toledo_collection_calacattamanhattan",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/smartstone-warranty",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/quartz-countertop-in-statuario-venato-by-jm-homes-bendigo",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/trade-downloads/marengo-2",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/Grafite-Grigio",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/larger-slab-size/smartstone_larger-slab-size",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/mowbray-elysium-designed/page/6",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/Super-White",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/sales_request-a-sample",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/product/onyx-verde",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/in-focus",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/wp-content/:pathMatch(.*)",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/wp-includes/:pathMatch(.*)",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/wp-login.php",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/category/:pathMatch(.*)",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  },
  {
    name: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30IMeta?.name,
    path: "/tag/:pathMatch(.*)",
    component: component_45stubmY_450xtoXxZjIT3vi0lNdeB_T3bIYsXPnOnOkLR4R30I
  }
]